'use strict';

// require our custom
var sw = require('js/lib/sw');
var $ = require('js/sw-jquery/sw-jquery');
var notifications =  require('js/lib/notifications/sw-notifications');

var NOTY_CLICK_EVENT = 'click.noty-click';
/**
 *
 * register a click handler on the body to be invoked when
 * only for elements with the data attribute:
 *
 *
 * Example usage:
 *
 * <a data-sw-noty data-sw-noty-id="wes tutorial" data-sw-noty-href="/custom-modal?source=edu-discount" data-sw-noty-timeout="false" data-sw-noty-layout="swCenterFull" href="#" class="sw--text-bold">See the deals!</a>
 *
 *
 * data-sw-noty
 * data-sw-noty-content=<text contents for noty>
 * data-sw-noty-html-content=<html content for noty>
 * data-sw-noty-id=<unique identifier>
 * data-sw-noty-href=<content endpoint>
 * data-sw-noty-timeout=<timeout duration for noty>
 * data-sw-noty-layout=<name of layout to use>
 * data-sw-noty-close-with<array of closing options>
 *
 */
$('body').on('click', '[data-sw-noty]', function(e) {
  var $el = $(this);

  // Invalidates jQuery's internal data cache
  $el.removeData();

  // Get content from the dom element
  var content = $el.data('swNotyContent');

  // Get content from another div
  var htmlContentSelector = $el.data('swNotyHtmlContentSelector');
  if (htmlContentSelector) {
    content = $(htmlContentSelector).html();
  }

  // Get a noty id to avoid double-click issues
  var notyId  = $el.data('swNotyId');

  // Load content from a server endpoint
  var href = $el.attr('href');
  var notyHref = $el.data('swNotyHref');

  if(href) {
    e.preventDefault();

    if (href === '#') {
      href = notyHref;
    }

  } else {
    href = notyHref;
  }

  // Load content from a server endpoint
  var data = $el.data('swNotyData');
  data = data || {};

  // Specify how long (in milliseconds) to show the noty
  var timeout = $el.data('swNotyTimeout');

  // Specify which noty layout to use
  var layout = $el.data('swNotyLayout');

  // Specify wheter or not to use a modal
  var modal = $el.data('swNotyModal') || false;

  // Specify which noty layout to use
  var type = $el.data('swNotyType') || 'content';

  // Specify how the noty should be able to closed
  var closeWith = $el.data('swNotyCloseWith') || ['button', 'click'];

  var closeSelectors = $el.data('swNotyCloseSelectors');

  // elements in noty from closeSelectors
  var $closeEls;

  // let's minimize our code footprint
  var notyOptions = {
    id:       notyId,
    timeout:  timeout,
    layout:   layout,
    modal:    modal,
    type:     type,
    closeWith: closeWith,
    callback: {
      onShow: function onShow() {
        var noty = this;
        $closeEls = closeSelectors ? noty.$bar.find(closeSelectors) : $();
        $closeEls.on(NOTY_CLICK_EVENT, function notyCloseClick() {
          noty.close();
        });
        // Use the sw event bus to trigger a noty close
        // this is useful for Vue components
        sw.on('sw-noty-close', function(notyCloseId) {
          if (notyCloseId === notyId) {
            noty.close();
          }
        });
      },
      afterClose: function afterClose() {
        $closeEls.off(NOTY_CLICK_EVENT);
      }
    }
  };


  if (type === 'confirm') {

    notifications.confirm(content, href);

  } else if (href) {

    // Use AJAX to retrive data from an endpoint
    $.ajax({
      url:      href,
      data: data,
      success:  function(data) {
        notifications.displayNoty(data, notyOptions);
      }
    });

  } else if (content) {
    // Display test content to the user
    notifications.displayNoty(content, notyOptions);
  }


});
